<template>
  <el-container>
    <main-menu></main-menu>
    <el-header>
      <main-header />
      <calendar class="restaurant-calendar"></calendar>
    </el-header>
    <el-container class="restau-container" :class='{ "restau-container-mod-switch": getModSwitchTable }'>
      <div class="restau-mod-switch" :class='{ "restau-mod-switch_on": getModSwitchTable }'>
        <span style="margin-right:15px">Changer Table</span>
        <el-button class="red" @click="abordSwitchMod()">Annuler</el-button>
        <el-button class="green" v-if="getSwitchTableCanBeValidated" @click="validSwitchMod()">Valider</el-button>
      </div>
      <el-aside class="pan-left" width="415px">
        <multi-room-stat class="pan-left-stat-mob" />
        <main-left-side />
      </el-aside>
      <el-main class="pan-right">
        <main-right-side />
      </el-main>
      <transition name="fade">
        <popup-manage-resa v-if="isVisiblePopupManageServices" />
      </transition>
      <transition name="fade">
        <popup-table-selected v-if="isVisiblePopupTableSelected && !getModSwitchTable" />
      </transition>
    </el-container>
    <transition name="fade">
      <services v-if="isVisibleScreenServices" />
      <events v-if="isVisibleScreenEvents" />
      <discount v-if="isVisibleScreenDiscount" />
      <LockedServicesList v-if="isVisibleScreenLockedServices" />
      <LockedRoomsList v-if="isVisibleScreenLockedRooms" />
      <integration v-if="isVisibleScreenIntegration" />
      <infos v-if="isVisibleScreenInfos" />
      <reviews v-if="isVisibleScreenReviews" />
      <ClientsBook v-if="isVisibleScreenClientBook" />
      <Stats v-if="isVisibleScreenStats" />
      <CashList v-if="isVisibleScreenCashList" />
      <ResaList v-if="isVisibleScreenResaList" />
    </transition>
    <el-dialog title="Informations client" top="9vh" :visible="isVisibleDialogEditClient" width="80%"
      :before-close="closeDialogEditClient">
      <client-edit :cid="getCidEditing"></client-edit>
    </el-dialog>
    <el-dialog title="Annulation de la réservation" top="9vh" :visible="isVisibleDialogCancelResa" width="80%"
      :before-close="closeDialogCancelResa">
      <resa-cancelling></resa-cancelling>
    </el-dialog>
    <el-dialog title="Edition caution / prépaiement" top="9vh" :visible="isVisibleDialogEditCash" width="80%"
      :before-close="closeDialogEditCash">
      <cash-edit></cash-edit>
    </el-dialog>
    <el-dialog title="Edition d'évènements" top="9vh" ref="dialogEvent" :visible="isVisibleDialogEditEvent" width="80%"
      :before-close="closeDialogEditEvent">
      <event-edit></event-edit>
    </el-dialog>
    <el-dialog title="Edition des réductions" top="9vh" ref="dialogDiscount" :visible="isVisibleDialogEditDiscount"
      width="80%" :before-close="closeDialogEditDiscount">
      <discount-edit></discount-edit>
    </el-dialog>
    <el-dialog title="Erreur" :visible.sync="isVisibleDialogError" width="30%" :before-close="closeDialogError">
      <span>Les informations renseignées ne sont pas correctes</span>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="closeDialogError()">OK</el-button>
      </span>
    </el-dialog>
    <el-dialog title="Vous allez valider un paiement" :visible.sync="isVisibleDialogPayement" width="50%"
      :before-close="closeDialogPayement">
      <resa-payement></resa-payement>
    </el-dialog>
    <div :class="['pointWS', { 'pointWS-isAlive': socketIsAlive }]"></div>
  </el-container>
</template>

<script>

import { Notification } from 'element-ui'
import { mapActions, mapGetters, mapMutations } from 'vuex'
import Calendar from './calendar/Calendar.vue'
import CashEdit from './cash/CashEdit'
import CashList from './cash/CashList'
import ClientEdit from './clients/ClientEdit'
import ClientsBook from './clients/ClientsBook'
import DiscountEdit from './discount/DiscountEdit'
import Discount from './discount/DiscountList'
import EventEdit from './events/EventEdit'
import Events from './events/EventsList'
import Infos from './parameters/InfosRestaurant'
import Integration from './parameters/Integration'
import Reviews from './parameters/ReviewsRestaurant.vue'
import PopupManageResa from './popups/PopupManageResa'
import PopupTableSelected from './popups/PopupTableSelected'
import ResaCancelling from './reservation/ResaCancelling'
import ResaList from './reservation/ResaList'
import ResaPayement from './reservation/ResaPayement'
import LockedRoomsList from './room/LockedRoomsList'
import MultiRooms from './room/MultiRooms.vue'
import MultiRoomStat from './room/MultiRoomStat.vue'
import LockedServicesList from './services/LockedServicesList'
import Services from './services/Services'
import Stats from './stats/Stats'
import MainHeader from './zonning/MainHeader'
import MainLeftSide from './zonning/MainLeftSide'
import MainMenu from './zonning/MainMenu'
import MainRightSide from './zonning/MainRightSide'

export default {
  name: 'Restaurant',
  components: { PopupTableSelected, Services, Events, Discount, DiscountEdit, EventEdit, Integration, Infos, Reviews, ResaCancelling, ResaPayement, ClientsBook, Stats, MainMenu, MainRightSide, MainLeftSide, MainHeader, Calendar, PopupManageResa, ClientEdit, CashList, CashEdit, ResaList, LockedServicesList, LockedRoomsList, MultiRooms, MultiRoomStat }, props: {
    firstTime: false
  },
  data() {
    return {
      now: Math.trunc((new Date()).getTime() / 1000),
      socketInterval: null,
      socketIsAlive: false
    }
  },
  computed: {
    ...mapGetters({
      isVisibleScreenServices: 'displayer/isVisibleScreenServices',
      isVisibleScreenEvents: 'displayer/isVisibleScreenEvents',
      isVisibleScreenDiscount: 'displayer/isVisibleScreenDiscount',
      isVisibleScreenLockedServices: 'displayer/isVisibleScreenLockedServices',
      isVisibleScreenLockedRooms: 'displayer/isVisibleScreenLockedRooms',
      isVisibleScreenIntegration: 'displayer/isVisibleScreenIntegration',
      isVisibleScreenInfos: 'displayer/isVisibleScreenInfos',
      isVisibleScreenReviews: 'displayer/isVisibleScreenReviews',
      isVisiblePopupTableSelected: 'displayer/isVisiblePopupTableSelected',
      isVisiblePopupManageServices: 'displayer/isVisiblePopupManageServices',
      isVisibleScreenClientBook: 'displayer/isVisibleScreenClientBook',
      isVisibleScreenStats: 'displayer/isVisibleScreenStats',
      isVisibleScreenCashList: 'displayer/isVisibleScreenCashList',
      isVisibleScreenResaList: 'displayer/isVisibleScreenResaList',
      isVisibleDialogCancelResa: 'displayer/isVisibleDialogCancelResa',
      isVisibleDialogEditCash: 'displayer/isVisibleDialogEditCash',
      isVisibleDialogEditEvent: 'displayer/isVisibleDialogEditEvent',
      isVisibleDialogEditDiscount: 'displayer/isVisibleDialogEditDiscount',
      isVisibleDialogError: 'displayer/isVisibleDialogError',
      isVisibleDialogEditClient: 'displayer/isVisibleDialogEditClient',
      isVisibleDialogPayement: 'displayer/isVisibleDialogPayement',
      getCidEditing: 'newClients/getCidEditing',
      getModSwitchTable: 'newReservations/getModSwitchTable',
      getResaToSwitch1: 'newReservations/getResaToSwitch1',
      getResaToSwitch2: 'newReservations/getResaToSwitch2',
      getSelectedTables: 'newRooms/getSelectedTables',
      getSelectedRoom: 'newRooms/getSelectedRoom',
      getTableDatas: 'newRooms/getTableDatas',
      getSocketState: 'webSockets/getSocketState',
      getSocket: 'webSockets/getSocket',
      getLastMessage: 'webSockets/getLastMessage'
    }),
    getSwitchTableCanBeValidated: function () {
      if (this.getResaToSwitch1.data !== undefined) {
        if (this.getResaToSwitch2.data !== undefined) return true
        if (this.getSelectedTables.length > 0) {
          let haveResa = false
          let checkSelectedTables = this.getSelectedTables
          if (this.getSelectedRoom === this.getResaToSwitch1.room) checkSelectedTables = this.getSelectedTables.filter(tid => !this.getResaToSwitch1.tids.includes(tid))
          if (checkSelectedTables.length > 0) {
            checkSelectedTables.forEach(tid => {
              if (this.getTableDatas(this.getSelectedRoom, tid).resaId.length > 0) haveResa = true
            })
            if (!haveResa) return true
          }
        }
      }
      return false
    }
  },
  methods: {
    ...mapMutations({
      setDialogEditClient: 'displayer/setDialogEditClient',
      setDialogCancelResa: 'displayer/setDialogCancelResa',
      setDialogEditCash: 'displayer/setDialogEditCash',
      setDialogEditEvent: 'displayer/setDialogEditEvent',
      setDialogEditDiscount: 'displayer/setDialogEditDiscount',
      setDialogError: 'displayer/setDialogError',
      setDialogPayement: 'displayer/setDialogPayement',
      setModSwitchTable: 'newReservations/setModSwitchTable',
      setResaToSwitch1: 'newReservations/setResaToSwitch1',
      setResaToSwitch2: 'newReservations/setResaToSwitch2',
      setPopupTableSelected: 'displayer/setPopupTableSelected'
    }),
    ...mapActions({
      loadStoreModules: 'loadStoreModules',
      unSelectedTables: 'newRooms/unSelectedTables',
      switchResa: 'newReservations/switchResa',
      loadByTimestamp: 'newReservations/loadByTimestamp',
      preLoadRoomsStore: 'newRooms/preLoadRoomsStore',
      updateRoomInformation: 'newRooms/updateRoomInformation',
      loadServicesStore: 'newServices/loadServicesStore',
      loadEventsStore: 'events/loadEventsStore',
      loadDiscoutStore: 'discount/loadDiscountStore',
      loadlockedDays: 'newServices/loadlockedDays',
      loadlockedRooms: 'newRooms/loadlockedRooms',
      loadlockedTables: 'newRooms/loadlockedTables',
      loadCashDays: 'cash/loadCashDays',
      login: 'newUsers/login',
      createSocketConnection: 'webSockets/createSocketConnection',
      forceCloseSocket: 'webSockets/forceCloseSocket',
      sendPing: 'webSockets/sendPing',
      updateAppOn: 'updateAppOn',
      syncAllResas: 'newReservations/syncAllResas',
      cleanNotifications: 'serviceWorker/cleanNotifications',
      checkAppVersion: 'checkAppVersion',
      initServiceWorker: 'serviceWorker/initServiceWorker',
      checkNotificationAuth: 'serviceWorker/checkNotificationAuth',
      serviceWorkerMessageListener: 'serviceWorker/serviceWorkerMessageListener'
    }),
    closeDialogEditClient: function () {
      this.setDialogEditClient(false)
    },
    closeDialogCancelResa: function () {
      this.setDialogCancelResa(false)
    },
    closeDialogEditCash: function () {
      this.setDialogEditCash(false)
    },
    closeDialogEditEvent: function () {
      this.$refs.dialogEvent.$el.scrollTop = 0
      this.setDialogEditEvent(false)
    },
    closeDialogEditDiscount: function () {
      this.$refs.dialogDiscount.$el.scrollTop = 0
      this.setDialogEditDiscount(false)
    },
    closeDialogError: function () {
      this.setDialogError(false)
    },
    closeDialogPayement: function () {
      this.setDialogPayement(false)
    },
    abordSwitchMod: function () {
      this.setResaToSwitch1({})
      this.setResaToSwitch2({})
      this.unSelectedTables()
      this.setModSwitchTable(false)
      this.setPopupTableSelected(false)
    },
    validSwitchMod: function () {
      // check if is possible with hours
      this.switchResa().then(res => {
        this.setResaToSwitch1({})
        this.setResaToSwitch2({})
        this.unSelectedTables()
        this.setModSwitchTable(false)
      }).catch(function (err) {
        Notification.error({
          title: 'Erreur',
          message: err.message,
          position: 'bottom-right'
        })
      })
    },
    onWindowFocusChange: function (e) {
      if ({ focus: 1, pageshow: 1 }[e.type]) {
        if (this.tabFocus) return
        this.tabFocus = true
        this.checkAppVersion()
        let route = this.$router.currentRoute.name
        if (route !== 'PRedirect') this.syncAllResas(false)
        this.loadServicesStore()
        this.loadEventsStore()
        this.loadDiscoutStore()
        this.loadlockedDays()
        this.loadlockedRooms()
        this.loadlockedTables()
        this.loadCashDays()
        this.webSocketInit()
        if (navigator && navigator.serviceWorker && navigator.serviceWorker.controller) {
          this.cleanNotifications()
        }
      } else if (this.tabFocus) {
        this.tabFocus = !this.tabFocus
      }
    },
    detectFocusOut: function () {
      window.addEventListener('focus', this.onWindowFocusChange)
      window.addEventListener('blur', this.onWindowFocusChange)
      window.addEventListener('pageshow', this.onWindowFocusChange)
      window.addEventListener('pagehide', this.onWindowFocusChange)
    },
    webSocketInit: function () {
      this.forceCloseSocket()
      clearInterval(this.socketInterval)
      this.socketInterval = null
      // each minuite check websocket state
      this.socketInterval = setInterval(() => {
        if (this.getSocketState !== 1) {
          console.error('webSocket connection lost')
          this.socketIsAlive = false
          this.createSocketConnection()
        } else {
          // ping
          this.sendPing()
          this.socketIsAlive = true
        }
      }, 5000)
    },
    serviceWorkerInit: async function () {
      if (this.$router.currentRoute.name !== 'PRedirect' && this.$router.currentRoute.name !== 'Permanence') {
        await this.initServiceWorker()
        this.checkNotificationAuth()
        this.serviceWorkerMessageListener()
      }
    }
  },
  watch: {
    'getLastMessage': function (val, oldVal) {
      if (val.data === 'pong') {
      } else if (JSON.parse(val.data).type === 'RESA') {
        if (JSON.parse(val.data).ts !== undefined) {
          this.loadByTimestamp(JSON.parse(val.data).ts)
        }
      } else if (JSON.parse(val.data).type === 'ROOMS') {
        this.updateRoomInformation()
      } else if (JSON.parse(val.data).type === 'TABLES') {
        this.preLoadRoomsStore()
      } else if (JSON.parse(val.data).type === 'VERSION') {
        // reload app
        this.updateAppOn()
      } else if (JSON.parse(val.data).type === 'SERVICES') {
        // reload app
        this.loadServicesStore()
      } else if (JSON.parse(val.data).type === 'EVENTS') {
        // reload app
        this.loadEventsStore()
      } else if (JSON.parse(val.data).type === 'DISCOUNT') {
        // reload app
        this.loadDiscountStore()
      } else if (JSON.parse(val.data).type === 'LOCKEDSERVICES') {
        // reload app
        this.loadlockedDays()
      } else if (JSON.parse(val.data).type === 'LOCKEDROOMS') {
        // reload app
        this.loadlockedRooms()
      } else if (JSON.parse(val.data).type === 'LOCKEDTABLES') {
        // reload app
        this.loadlockedTables()
      } else if (JSON.parse(val.data).type === 'CASHDAYS') {
        // reload app
        this.loadCashDays()
      }
    }
  },
  mounted: function () {
    this.webSocketInit()
    this.serviceWorkerInit()
    this.detectFocusOut()
  },
  destroyed: function () {
    window.removeEventListener('focus', this.onWindowFocusChange)
    window.removeEventListener('blur', this.onWindowFocusChange)
    window.removeEventListener('pageshow', this.onWindowFocusChange)
    window.removeEventListener('pagehide', this.onWindowFocusChange)
  }
}
</script>

<style lang="scss">
@use "../styles/vars";
@use "../styles/mixins";

@use "../styles/components/elements/popup";
@use "../styles/components/elements/blackInputs";
@use "../styles/components/elements/buttons";
@use "../styles/components/elements/nav";
@use "../styles/components/elements/notif";
@use "../styles/components/elements/selector";
@use "../styles/components/layout/screens";
@use "../styles/components/layout/calendar";
@use "../styles/components/layout/mainSide";

@use "../styles/animations/mainAnims";

.el-header {
  padding: 8.5px 12.5px;
  background-color: var(--dark__main_color-light);
  border: 1px solid var(--dark__main_color);
  height: 80px !important;

  @include mixins.mobile-landscape {
    height: 60px !important;
    padding: 8.5px 12.5px;
  }

  @include mixins.mobile-portrait {
    height: 200px !important;
    padding: 8.5px 12.5px;
  }
}

.pan {
  &-left {
    width: 415px;

    @include mixins.mobile-landscape {
      width: 300px !important;
    }

    @include mixins.mobile-portrait {
      width: 100% !important;
    }

    &-stat-mob {
      display: none;

      @include mixins.mobile-portrait {
        display: inline-flex;
        align-items: center;
        justify-content: center;
        width: 100%;
      }
    }

    @include mixins.mobile-portrait {
      .aside.el-row {
        height: calc(100% - 49px) !important;
      }
    }
  }

  &-right {
    @include mixins.mobile-portrait {
      display: none;
    }
  }
}

.v-modal {
  z-index: 1000 !important;
}

.el-dialog__wrapper {
  z-index: 1001 !important;
}

.pointWS {
  height: 10px;
  width: 10px;
  border-radius: 50%;
  border: 1px solid var(--text_color_grey);
  position: absolute;
  right: 5px;
  bottom: 7px;

  &-isAlive {
    background-color: var(--text_color_grey);
  }
}
</style>
